import { useGetMachinesQuery } from '../../gql/generated';
import { MobileSearchableSelect } from '../MobileSearchableSelect';
import {
  InlineSearchableList,
  SearchableSelect,
  SearchableSelectOption,
} from '../SearchableSelect';

interface AlarmMachineFilterProps {
  selectedValues: string[];
  onChange: (values: string[]) => void;
  onClose?: () => void;
  variant?: 'inline' | 'popover' | 'mobile';
}

export function AlarmMachineFilter({
  selectedValues,
  onChange,
  onClose,
  variant = 'inline',
}: AlarmMachineFilterProps) {
  // Fetch all machines from GraphQL
  const { data, loading } = useGetMachinesQuery({
    variables: {
      pagination: {
        limit: 1000, // Get all machines for filter
        offset: 0,
      },
    },
    fetchPolicy: 'cache-and-network',
  });

  // Transform machine data to options format, using machineId as value
  const options: SearchableSelectOption[] =
    data?.machines.rows.map((machine) => ({
      value: machine.machineId,
      label: machine.displayName || machine.machineId,
    })) || [];

  const handleClear = () => {
    onChange([]);
  };

  if (variant === 'mobile') {
    return (
      <MobileSearchableSelect
        options={options}
        selectedValues={selectedValues}
        onSelectionChange={onChange}
        placeholder={loading ? 'Loading machines...' : 'Select machines'}
        label='Machine'
      />
    );
  }

  if (variant === 'popover') {
    return (
      <SearchableSelect
        options={options}
        selectedValues={selectedValues}
        onSelectionChange={onChange}
        placeholder={loading ? 'Loading machines...' : 'Select machines'}
      />
    );
  }

  return (
    <InlineSearchableList
      options={options}
      selectedValues={selectedValues}
      onSelectionChange={onChange}
      placeholder={loading ? 'Loading...' : 'Search machines...'}
      onClearFilter={handleClear}
      onClose={onClose}
    />
  );
}
